import { FC } from 'react'

import styled from 'styled-components'

import { Avatar } from '../../Avatar'

interface CuratorInfoProps {
  avatarUrl?: string
  curatorName: string
  playlistCount: number
}

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${({ theme }) => theme.color.white};
  flex: 1;
  max-width: 340px;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`

const CuratorName = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
`

const PlaylistInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
`

const PlaylistCount = styled.span`
  white-space: nowrap;
`

const PlaylistText = styled.span`
  flex: 1;
  min-width: 0;
`

export const CuratorInfo: FC<CuratorInfoProps> = ({
  avatarUrl,
  curatorName,
  playlistCount,
}) => (
  <InfoContainer>
    <Avatar src={avatarUrl} width={54} height={54} />
    <TextContainer>
      <CuratorName>{curatorName}</CuratorName>
      <PlaylistInfo>
        <PlaylistCount>{playlistCount}</PlaylistCount>
        <PlaylistText>playlists</PlaylistText>
      </PlaylistInfo>
    </TextContainer>
  </InfoContainer>
)
